import { call, put, takeEvery } from 'redux-saga/effects'

import api from '../../utils/api'
import * as apiErrorHelpers from '../../helpers/apiErrorHelpers'
import * as sessionHelpers from '../../helpers/sessionHelpers'

export function* loadOrderIssues(action) {
  try {
    const payload = action.payload || {}
    const { skipLoading } = payload
    if (!skipLoading) {
      yield put({ type: 'SET_LOADING' })
      yield put({ type: 'UNSET_LOADING_ERROR' })
    }

    api.setAuthApi({
      'Authorization': sessionHelpers.getApplicationCookie('authentication_token')
    })

    yield put({ type: 'ORDER_ISSUES_LOAD_REQUESTED' })

    const request = {
      url: '/order_issues',
      body: {}
    }

    const response = yield call(api.utility.get, api.path(request.url), { body: request.body })

    apiErrorHelpers.catchErrors(response.body)

    yield put({
      type: 'ORDER_ISSUES_LOAD_SUCCEEDED',
      payload: { data: response.body }
    })

    if (!skipLoading) yield put({ type: 'UNSET_LOADING'})
  }
  catch (errors) {
    // eslint-disable-next-line
    errors = apiErrorHelpers.formatInternalErrors(errors)

    yield put({ type: 'LOADING_FAILED' })
    yield put({ type: 'SET_LOADING_ERROR' })
    yield put({ type: 'UNSET_LOADING' })

    const afterRequestData = {
      alertMessage: apiErrorHelpers.toString(errors)
    }
    yield call(action.callback, 'failure', afterRequestData)

    apiErrorHelpers.consoleLog(errors)
  }
} // loadOrderIssues()

export default function* shopOrderSaga() {
  yield takeEvery('ORDER_ISSUES_LOAD_SAGA', loadOrderIssues)
}
